import i18n from '@i18n';
import * as yup from 'yup';

export const validationSchema = () =>
  yup.object({
    dateEvents: yup.string().required(i18n.t('VALIDATION.REQUIRED')),
    name: yup.string(),
  });
